export const data = [
    {
    "id": "JavaScript",
    "data": [
      {
        "x": 2000,
        "y": 29
      },
      {
        "x": 2001,
        "y": 12
      },
      {
        "x": 2002,
        "y": 19
      },
      {
        "x": 2003,
        "y": 20
      },
      {
        "x": 2004,
        "y": 11
      },
      {
        "x": 2005,
        "y": 21
      }
    ]
  },
  {
    "id": "ReasonML",
    "data": [
      {
        "x": 2000,
        "y": 11
      },
      {
        "x": 2001,
        "y": 15
      },
      {
        "x": 2002,
        "y": 10
      },
      {
        "x": 2003,
        "y": 30
      },
      {
        "x": 2004,
        "y": 15
      },
      {
        "x": 2005,
        "y": 21
      }
    ]
  },
  {
    "id": "TypeScript",
    "data": [
      {
        "x": 2000,
        "y": 21
      },
      {
        "x": 2001,
        "y": 17
      },
      {
        "x": 2002,
        "y": 24
      },
      {
        "x": 2003,
        "y": 17
      },
      {
        "x": 2004,
        "y": 27
      },
      {
        "x": 2005,
        "y": 25
      }
    ]
  },
  {
    "id": "Elm",
    "data": [
      {
        "x": 2000,
        "y": 21
      },
      {
        "x": 2001,
        "y": 21
      },
      {
        "x": 2002,
        "y": 30
      },
      {
        "x": 2003,
        "y": 15
      },
      {
        "x": 2004,
        "y": 29
      },
      {
        "x": 2005,
        "y": 21
      }
    ]
  },
  {
    "id": "CoffeeScript",
    "data": [
      {
        "x": 2000,
        "y": 24
      },
      {
        "x": 2001,
        "y": 28
      },
      {
        "x": 2002,
        "y": 12
      },
      {
        "x": 2003,
        "y": 17
      },
      {
        "x": 2004,
        "y": 17
      },
      {
        "x": 2005,
        "y": 22
      }
    ]
  }
]
